import React from "react"
import { MobileNumberField } from "../../../common/Fields"
import { withFormik, Form } from "formik"
import { parsePhoneNumber } from "libphonenumber-js"
import * as Yup from "yup"
import { API, API_PUBLIC } from "../../../api"
import "./CheckForgotPasswordForm.css"

function CheckForgotPasswordBaseForm(props) {
  return (
    <Form className="CheckForgotPasswordForm">
      <span>
        <label>Mobile Number</label>
        <MobileNumberField
          groupName="mobile"
          countryCodeName="countryCode"
          mobileNumberName="mobileNumber"
          errors={props.errors}
          touched={props.touched}
          values={props.values}
        />
      </span>
      <button className="black" type="submit" disabled={props.isSubmitting}>
        {`${props.isSubmitting ? "Resetting..." : "Reset my password"}`}
      </button>
      <button
        className="button-link"
        type="button"
        onClick={props.hideForgotPassword}
      >
        Return to Log in
      </button>
    </Form>
  )
}

const CheckForgotPasswordForm = withFormik({
  mapPropsToValues: () => {
    return {
      mobile: {
        countryCode: "",
        mobileNumber: ""
      }
    }
  },
  validationSchema: Yup.object().shape({
    mobile: Yup.object()
      .shape({
        countryCode: Yup.string()
          .matches(
            /^($)|(\+?\d{1,3}$|\d{1,4})/,
            "Please enter a valid country code."
          )
          .max(4, "Please enter a valid country code.")
          .typeError("Country code and mobile number should be filled.")
          .required("Please enter a country code"),
        mobileNumber: Yup.string()
          .matches(/^($)|([0-9]{4,10})/, "Please enter a valid mobile number.")
          .max(13, "Please enter a valid mobile number.")
          .required("Please enter a mobile number")
          .typeError("Country code and mobile number should be filled.")
      })
      .test("test-phone", "Invalid mobile number", function(mobile) {
        if (`${mobile.countryCode}${mobile.mobileNumber}` !== "") {
          try {
            parsePhoneNumber(`${mobile.countryCode}${mobile.mobileNumber}`)
            return true
          } catch (e) {
            return false
          }
        }
        return true
      })
  }),
  handleSubmit: async (
    values,
    { props, setSubmitting, setErrors, setStatus }
  ) => {
    const { mobile } = values
    const forgotUrl = `customers/${props.uuid}/forgot_password`
    const checkMobile = await API_PUBLIC.get(
      `/customers/${props.uuid}/${values.mobile.countryCode}${
        values.mobile.mobileNumber
      }`
    )
    const {
      data: { has_account, customer }
    } = checkMobile
    try {
      if (!has_account) {
        throw new Error("customers/mobile-does-not-exist")
      }
      console.log(checkMobile)
      const res = await API.post(
        forgotUrl,
        JSON.stringify({
          mobile: `${mobile.countryCode}${mobile.mobileNumber}`,
          order_uuid: props.orderUuid
        })
      )
      if (res) {
        props.setSuccess(true)
        props.setEmail(customer.email)
      }
    } catch (err) {
      if (err && err.message === "customers/mobile-does-not-exist") {
        setErrors({
          mobile: "The mobile number you entered is currently not in use."
        })
      }
      if (
        err &&
        err.response &&
        err.response.data &&
        err.response.data.message &&
        err.response.data.message === "ACCOUNT_NOT_FOUND!"
      ) {
        setErrors({
          mobile: "The mobile number you entered is currently not in use."
        })
      }
      setStatus({ success: false })
    } finally {
      setSubmitting(false)
    }
  },
  displayName: "CheckForgotPasswordForm"
})(CheckForgotPasswordBaseForm)

export default CheckForgotPasswordForm
